const messages = {
  title: "Ценоразписи и продуктови брошури",
  title_media: "Ценоразписи и продуктови брошури",
  description:
    "Изтеглете тук най-новите брошури и листовки за нашите гуми Bridgestone и Firestone за леки автомобили, SUV и търговски превозни средства.",
  short_description:
    "Тук можете да намерите материали за социални медии, in-store TV и други.",
  mediaCategories: {
    products: "Продукти",
    brand_and_solutions: "Марка и решения",
    season_and_promotions: "Сезон и промоции",
    format: "формат",
    cars_and_vans: "Автомобил, джип, комунален",
    truck_and_buses: "Тежкотоварни автомобили и автобуси",
    motorcycle: "мотоциклет",
    agriculture: "Селско стопанство",
    construction_machinery: "Строителни машини",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Материали",
    brochures: "Продуктови брошури",
    price_list: "Ценоразписи",
    materials: "Материали",
    video_in_store: "Видео със субтитри",
    video_online: "Видео без субтитри",
    video: "видео",
    banner_website: "Банер",
    banner_social_media: "Социалните мрежи",
    logos: "Логота",
    summer: "лято",
    winter: "Зима",
    all_season: "Всички сезони",
    promotions: "Промоции",
    price: "Pricat",
  },
  mediasPage: {
    title: "МЕДИЙНА БИБЛИОТЕКА",
    description:
      "Добре дошли в секцията за медии, посветена на   \n" +
      "продуктите Bridgestone и Firestone.  \n <br> <br>" +
      "Ще откриете визуализации на продукти,   \n" +
      "логотипи, както и широк избор от   \n" +
      "банери, видеоклипове и цифрови материали   \n" +
      "за използване на вашия уебсайт или в   \n" +
      "социалните мрежи.  ",
    bDrive: {
      title: "Снимки на продукти",
      description:
        "Текущите изображения   \n" +
        "могат да бъдат изтеглени   \n" +
        "от нашия портал B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "ОТКРИВАНЕ",
  },
  searchMedia: "Въведете ключова дума",
  searchResults: "Резултати от търсенето",
};

export default {
  messages,
};
